module.exports = __webpack_public_path__ + "static/location-icon-1e08ffc665b5413afb03d6b0e8e949cb.png";